import { axiosConfigs } from 'tradera/utils/api';
import { marketingApiClient } from 'tradera/utils/http';
import {
    resetCharity,
    setCharityShippingInfo,
    setCharityId,
    setCharityFromDraft,
    setCharityInfo
} from 'tradera/apps/syi/state/reducers/charity';
import shippingActions from './shipping-actions';
import { logger } from 'packages/logger';

export const setCharityFromDraftAndFetchInfo =
    (charityFromDraft) => (dispatch) => {
        dispatch(setCharityFromDraft(charityFromDraft));
        dispatch(setCharityAndFetchInfo(charityFromDraft.charityId));
    };

export const resetCharityAndShippingInfo = () => setCharityAndFetchInfo(null);

export const setCharityAndFetchInfo = (charityId) => (dispatch) => {
    dispatch(shippingActions.resetSelected());
    dispatch(resetCharity());
    dispatch(setCharityId({ charityId }));
    dispatch(fetchCharityInfo(charityId));
    dispatch(fetchCharityShippingInfo(charityId));
};

const fetchCharityInfo = (charityId) => async (dispatch) => {
    if (!charityId) {
        return;
    }
    try {
        const response = await getCharity(charityId);
        dispatch(setCharityInfo(response.data));
    } catch (error) {
        if (error?.response?.status !== 404) {
            logger(error);
        }
    }
};

const fetchCharityShippingInfo = (charityId) => async (dispatch, getState) => {
    if (!charityId) {
        return;
    }
    try {
        const response = await getCharityShippingInfo(charityId);

        const isFreeShippingPaidByProviderEnabled =
            getState().environment.featureSwitches[
                'free-shipping-paid-by-provider'
            ];

        if (isFreeShippingPaidByProviderEnabled) {
            dispatch(setCharityShippingInfo(response.data));
            if (response.data.freeShippingPaidByProviderName) {
                dispatch({
                    type: 'FREE_SHIPPING_PAID_BY_PROVIDER',
                    payload: {
                        providerName:
                            response.data.freeShippingPaidByProviderName
                    }
                });
            }
        }
        if (response.data.forceFreeShipping) {
            dispatch({
                type: 'FORCE_FREE_SHIPPING'
            });
        }
    } catch (error) {
        if (error?.response?.status !== 404) {
            logger(error);
        }
    }
};

const getCharityShippingInfo = (charityId) =>
    marketingApiClient.get(`/charity-shipping-info?charityId=${charityId}`, {
        ...axiosConfigs.notAuthenticated,
        cancelTokenId: 'getCharityShippingInfo'
    });

const getCharity = (charityId) =>
    marketingApiClient.get(`/syi/charity-details?charityId=${charityId}`, {
        ...axiosConfigs.notAuthenticated,
        cancelTokenId: 'getCharity'
    });
